import React, { useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material'

import { useManagesupportDocument } from '../hooks/useManagesupportDocument';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import { ClientForm } from '../components/ClientForm';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { SupplierForm } from '../components/SupplierForm';
import { DataDsForm } from '../components/DataDsForm';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { DianErrorsDialog } from '../../../components/invoice/shared/Dialogs/DianErrorsDialog';
import { ProductsForm } from '../../../components/invoice/shared/ProductsForm';

export default function LayoutSupportDocument() {
    const [refreshTotals, setRefreshTotals] = useState(false);

    const {
        values,
        errorInputs,
        edit,
        errorDian,
        openDialogCompany,
        companies,
        loading,
        clients,
        valuesSelects,
        resolutions,
        productsFormRef,
        handleInputChange,
        handleDirectInputChange,
        setErrorDian,
        handleSelectCompany,
        handleSubmit,
        handleCancel,
        t
    } = useManagesupportDocument();

    const handleSend = () => handleSubmit('SEND');
    const handleSave = () => handleSubmit('SAVE');
    const onCloseErrorDian = () => setErrorDian(null);

    return (
        <Box sx={{ mx: 'auto' }}>
            <Typography variant="h4" gutterBottom>
                {t('invoice.title')}
            </Typography>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <DividerGradient />
                    <Typography variant="h6" gutterBottom>{t('suppliers.supplierInofo')}</Typography>
                    <SupplierForm
                        dto={values}
                        errorInputs={errorInputs}
                        clients={clients}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        t={t}
                    />

                    <DividerGradient />
                    <Typography variant="h6" gutterBottom>{t('client.clientInfo')}</Typography>
                    <ClientForm
                        dto={values}
                        t={t}
                    />

                    <DividerGradient />
                    <Typography variant="h6" gutterBottom>{t('invoice.infoInvoice')}</Typography>
                    <DataDsForm
                        dto={values}
                        dataSelects={valuesSelects}
                        resolutions={resolutions}
                        errorInputs={errorInputs}
                        handleInputChange={handleInputChange}
                        handleDirectInputChange={handleDirectInputChange}
                        setRefreshTotals={setRefreshTotals}
                        t={t}
                    />

                    <DividerGradient />
                    <Typography variant="h6" gutterBottom>{t('crm.products.title')}</Typography>
                    <ProductsForm
                        ref={productsFormRef}
                        handleDirectInputChange={handleDirectInputChange}
                        handleInputChange={handleInputChange}
                        refreshTotals={refreshTotals}
                        dto={values}
                    />

                    <ActionButtons
                        onCancel={handleCancel}
                        onSubmit={handleSave}
                        onSubmitOptional={handleSend}
                        labelOptional={t("send")}
                        disabledOptional={(edit && values.status_code === 'APR')}
                    />
                </CardContent>
            </Card>

            {loading && <LoadingOverlay isOpen={loading} />}
            {openDialogCompany && (
                <DialogSelectCompany
                    openDialogConfirm={openDialogCompany}
                    handleCancelConfirm={handleCancel}
                    handleConfirmAction={handleSelectCompany}
                    data={companies}
                />
            )}

            {(errorDian && errorDian?.ErrorMessage) && <DianErrorsDialog dianResponse={errorDian} onClose={onCloseErrorDian} />}
        </Box>
    )
}
